import React from "react"
import type { BugsnagErrorBoundary as BugsnagErrorBoundaryComponent } from "@bugsnag/plugin-react"
import { Bugsnag } from "common/lib/bugsnag"

const EmptyErrorBoundary: BugsnagErrorBoundaryComponent = ({ children }) => <>{children}</>

// More about how to use Bugsnag with React: https://docs.bugsnag.com/platforms/javascript/react/
export const BugsnagErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React) || EmptyErrorBoundary
